import { useCallback } from 'react';

import { useCurrentUser } from '@futrli/views/hooks/useCurrentUser';

/**
 * Loads the current user data
 */
export const useLoadUserData = () => {
  const view = useCurrentUser();
  const { currentUser, errorLoading, isPending, isRefreshing } = view.state;

  const reload = useCallback(async () => {
    await view.refresh();
  }, [view]);

  return {
    reload,
    data: currentUser,
    error: errorLoading,
    isLoading: isRefreshing,
    isLoadingOrInit: isPending || isRefreshing
  };
};
